import NavigationPage from '@/app/components/NavigationPage'
import { Button, Text } from '@/components'
import { ButtonContainer } from '@/app/pages/ava/BrandedPage'
import { useNavigation } from '@/app/hooks'

export function useViewModel() {
  const { pushToPath: navigate } = useNavigation()

  const onNavYes = () => navigate('/qr-code')

  const onNavNo = () => navigate('/email')

  return {
    onNavNo,
    onNavYes,
  }
}

export default function TeslaDetermineOwnerPage() {
  const { onNavNo, onNavYes } = useViewModel()
  return (
    <NavigationPage
      id="no-keycard-start"
      title="Are you with the owner?"
      progressBar={{
        completedSteps: 2,
        totalSteps: 2,
      }}
    >
      <NavigationPage.SingleCardContent>
        <div className="flex flex-col gap-4">
          <Text variant="body2">
            If so, we will need them to scan a QR code to grant you a virtual
            key.
          </Text>
          <Text variant="body2">
            If not, we will email them to ask for a virtual key in the next
            step.
          </Text>
        </div>
        <ButtonContainer>
          <Button id="yes-owner" variant="primary" onClick={onNavYes}>
            Yes
          </Button>
          <Button id="no-owner" variant="secondary" onClick={onNavNo}>
            No
          </Button>
        </ButtonContainer>
      </NavigationPage.SingleCardContent>
    </NavigationPage>
  )
}
